import { NgModule } from '@angular/core';
import { ExperimentClassDirective } from './directives';

@NgModule({
  declarations: [ExperimentClassDirective],
  exports: [ExperimentClassDirective],
})
export class AnalyticsUiModule {}
